// extracted by mini-css-extract-plugin
export default {"api-message":"ApiMessage_api-message__pRyMO","code":"ApiMessage_code__2rMaw"};